module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_FR.5339b087.txt";